import type { FaireProductEntity } from "../../entity_types/product";

export const p_xdzsz9bj9t: FaireProductEntity = {
  token: "p_xdzsz9bj9t",
  type: "product",
  name: "🌿 Plantitas Body Scrub – Smooth, Glow, Repeat",
  brandToken: "b_ad8bjvlw5g",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/2c2423e29ac4fa95dea74c9e55d24d7dddefaa9ee22d3d640af9f92cb0eb6588.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/db721f6f76c7861d6ceb2565595fd43f222b54ccef859233542f1eabcf2e7c46.jpeg",
    "https://cdn.faire.com/fastly/cbbce5ee4d76f2edb29bb4caf1ac4d653a116d3e629f9b3af7e36a1ded21a5f5.jpeg"
  ],
  priceDollars: 13.85,
  description: "\nInspired by our own garden, Plantitas Body Scrub is a gentle yet effective sugar scrub that buffs away dry skin, revealing a soft, radiant glow. Infused with nourishing plant-based oils and scented with pure essential oils, this scrub transforms your skincare routine into a self-care ritual.\n\nScented with essential oils of bergamot, sandalwood and basil, you'll enjoy a light and refreshing experience.\n\n\n\n✨ Why You’ll Love It:\n\n * \n🌿 Plant-Powered Exfoliation – Sugar crystals slough off dead skin while natural oils lock in moisture.\n\n * \n✨ Glow-Boosting Formula – Leaves skin feeling polished, hydrated, and oh-so-smooth.\n\n * \n🍃 Pure & Clean – Made with all-natural ingredients, no synthetic fragrances, just skin-loving botanicals. \n\nIngredients: The Sweet Ginger Scrub is made with Sucrose, Aqua, Glycerin, Sorbitol, Sodium Coco Isethionate, Potassium Sorbate, Sodium Chloride, Sweet Almond Oil, Essential Oils of Bergamot, Basil, Sandalwood and Mica Powder\n",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:52.057Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
